import _ from 'lodash';

export function convertDatasets(data, topic, isValue) {
  if (_.isEmpty(data)) return null;
  const results = [];
  if (isValue) {
    for (let i = 0; i < data?.length; i++) {
      if (data?.[i]?.key?.startsWith(topic)) {
        results?.push(data?.[i]?.value);
      }
    }
  } else {
    for (let i = 0; i < data?.length; i++) {
      if (data?.[i]?.topic?.startsWith(topic)) {
        results?.push(data?.[i]?.dataSet);
      }
    }
  }
  return isValue ? results[0] : results;
}
export function ModifyMenu(_array) {
  if (!Array.isArray(_array) || !_array) return [];
  return (
    Array.isArray(_array) &&
    _array.reduce((acc, cur) => {
      const indexEl = _array.findIndex(el => el.nameEng.indexOf('lottery') && cur.nameEng.indexOf('lottery'));
      if (indexEl !== -1) {
        return [...acc, { ...cur }];
      } else {
        return [...acc, { ...cur, sub: [] }];
      }
    }, [])
  );
}
export function convertDatasetsLists(data, topic) {
  const results = [];
  data.forEach(el => {
    const indexEl = topic.indexOf(el.key);
    if (indexEl !== -1) {
      return results.push(el.value);
    }
  }, []);

  return results;
}

function sortDataByKey(data) {
  return data.sort((a, b) => {
    const numA = parseInt(a.key.match(/\d+$/)?.[0] || 0, 10);
    const numB = parseInt(b.key.match(/\d+$/)?.[0] || 0, 10);
    return numA - numB;
  });
}
export function convertDataLists(data, keys) {
  const result = {};
  const sortData = sortDataByKey(data);
  keys.forEach(key => {
    const keyData = sortData.filter(item => item.key.startsWith(key));
    const values = keyData.map(item => item.value);
    result[key.substring(0, key.length - 1)] = values;
  });

  return result;
}

export function convertDataListsNonNullCount(data, keys) {
  const result = {};
  const sortData = sortDataByKey(data);

  keys.forEach(key => {
    const keyData = sortData.filter(item => item.key.startsWith(key));
    const values = keyData.map(item => item.value);
    const nonNullCount = values.filter(value => value !== null).length;

    result[key.substring(0, key.length - 1)] = {
      values,
      nonNullCount
    };
  });

  return result;
}
